@if (notifications.length !== 0) {
  <div class="wzb-notifications" [@animateToasts]>
    @for (notification of notifications; track notification.id; let i = $index) {
      <div class="wzb-notification" [@animateToasts] [ngClass]="'wzb-notification--' + notification.style">
        <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
        <div
          class="wzb-notification__bar"
          [style.animation-duration]="(notification.duration || duration) + 'ms'"
        ></div>

        <button class="btn-clean wzb-notification__close" (click)="removeNotification(i)" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" height=".6em" width=".6em">
            <path
              d="M.3 17.7c-.4-.4-.4-1 0-1.4l16-16c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-16 16c-.4.4-1 .4-1.4 0zm6.4-11c-.4.4-1 .4-1.4 0l-5-5C-.1 1.3-.1.7.3.3s1-.4 1.4 0l5 5c.4.4.4 1 0 1.4z"
            />
            <path d="M17.7 17.7c-.4.4-1 .4-1.4 0L8.6 10c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l7.7 7.7c.4.4.4 1 0 1.4z" />
          </svg>
        </button>

        <div class="wzb-notification__message">
          @if (notification.style) {
            <div class="wzb-notification__message__picto">
              @if (notification.style === NotifStatus.Success) {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" width="1.5em" height="1.5em">
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M12.103 24.1a12.05 12.05 0 1 1 10.12-5.59 1 1 0 1 1-1.69-1.07 10 10 0 1 0-2.85 2.95 1.001 1.001 0 0 1 1.12 1.66 12 12 0 0 1-6.7 2.05zm-1.023-8.086a.78.78 0 0 1-1.12 0l-4.72-4.669a.76.76 0 0 1 0-1.108.78.78 0 0 1 1.12 0l4.8 4.749c.24.237.24.712-.08 1.028zm.8-2.014a.76.76 0 0 1 0-1.108l5.76-5.655a.78.78 0 0 1 1.12 0 .76.76 0 0 1 0 1.108L13 14a.78.78 0 0 1-1.12 0z"
                  />
                </svg>
              }

              @if (notification.style === NotifStatus.Failed) {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="1.5em" height="1.5em">
                  <path
                    fill="currentColor"
                    d="M10 9v3-3zm0-1a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-9 5.5a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2H1zm9.01-16.528L4.028 13.263a1 1 0 0 1-1.73-1.005L9.135.498a1 1 0 0 1 1.724-.01l7 11.761a1 1 0 0 1-1.718 1.023l-6.13-10.3z"
                  />
                </svg>
              }
            </div>
          }

          <div class="wzb-notification__message__content">
            <p [innerHTML]="notification.message"></p>
          </div>
        </div>

        @if (notification.canCancelled) {
          <button class="btn-clean wzb-notification__button" (click)="cancelNotification(i)" type="button">
            Annuler
          </button>
        }

        @if (notification.callbackConfig) {
          <button
            class="btn-clean wzb-notification__button"
            (click)="notification.callbackConfig.callback()"
            type="button"
          >
            {{ notification.callbackConfig.text }}
          </button>
        }
      </div>
    }
  </div>
}
